import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkSkeleton } from './uitk-skeleton.esm.js';

var UitkBlockSkeleton = function (props) {
    var animation = props.animation, className = props.className, type = props.type;
    var cssClassNames = classNames("".concat(UitkSkeleton.baseClassName, "-block"), type && "".concat(UitkSkeleton.baseClassName, "-block-").concat(type), className);
    return React.createElement(UitkSkeleton, { className: cssClassNames, animation: animation });
};
UitkBlockSkeleton.displayName = 'UitkBlockSkeleton';
UitkBlockSkeleton.defaultProps = {
    type: 'square'
};

export { UitkBlockSkeleton };
